import {isObject, cloneDeep} from 'lodash';

import {
    ACCESSS_GRANTED,
    ADDRESS_CONFIRMED,
    AGENT_ADDED,
    AWAITING_SIGNATURES,
    COMPLETE,
    DISCLOSURE_UPDATES_IN_PROGRESS
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderStatusAppResource';

export const statusOrder = {
    CREATED: 'Created',
    ACCESS_GRANTED: 'Access Granted',
    ADDRESS_CONFIRMED: 'Address Confirmed',
    AGENT_ADDED: 'Agent Added',
    DISCLOSURE_UPDATES_IN_PROGRESS: 'Updates in Progress',
    AWAITING_SIGNATURES: 'Awaiting Signatures',
    COMPLETE: 'Complete',
};

export const disclosure = {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    COMPLETE: 'Complete',
};

import {SST_HSLP} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderSolutionAppResource';
import {
    PAY_AT_CLOSE,
    NO_COST,
    BILLED_SEPARATELY
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderPaymentTermAppResource';
import {
    PAY_AT_CLOSE as HSLP_PAY_AT_CLOSE,
    NO_COST as HSLP_NO_COST,
    BILLED_SEPARATELY as HSLP_BILLED_SEPARATELY
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuHslpUpsellPaymentTermAppResource';
import {
    AGENT as ORDERED_BY_AGENT
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderedByTypeAppResource';
import {
    AGENT as PURCHASED_BY_AGENT
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuHslpUpsellPurchasedByTypeAppResource';
import {
   NV, 
   PA, TX, OK, SC, NC
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuStateAppResource';

export const hslp = {
    NOT_PROTECTED: 'Not Protected',
    PAY_AT_CLOSE: 'Pay at Close',
    PROTECTED: 'Protected',
};

export const user = {
    AGENT: 'Agent',
    SELLER: 'Seller',
    BROKER: 'Broker',
};
export const hslpBadgeIcons = {
    'no-protection': require('@assets/images/v3/no-protection.png'),
    'protected-1-year-agent': require('@assets/images/v3/protected-1-year-agent.png'),
    'protected-2-year-agent': require('@assets/images/v3/protected-2-year-agent.png'),
    'protected-3-year-agent': require('@assets/images/v3/protected-3-year-agent.png'),
    'protected-2-year-seller': require('@assets/images/v3/protected-2-year-seller.png'),
    'protected-3-year-seller': require('@assets/images/v3/protected-3-year-seller.png'),
    'protected-4-year-seller': require('@assets/images/v3/protected-4-year-seller.png'),
    'reserved-1-year-agent': require('@assets/images/v3/reserved-1-year-agent.png'),
    'reserved-2-year-agent': require('@assets/images/v3/reserved-2-year-agent.png'),
    'reserved-3-year-agent': require('@assets/images/v3/reserved-3-year-agent.png'),
    'reserved-2-year-seller': require('@assets/images/v3/reserved-2-year-seller.png'),
    'reserved-3-year-seller': require('@assets/images/v3/reserved-3-year-seller.png'),
    'reserved-4-year-seller': require('@assets/images/v3/reserved-4-year-seller.png'),
}
export const disclosureInProgressValues = [DISCLOSURE_UPDATES_IN_PROGRESS, AWAITING_SIGNATURES];
export const disclosureNotStartedValues = [ACCESSS_GRANTED, ADDRESS_CONFIRMED, AGENT_ADDED];

export const orderStatus = (order) => {
    let status = statusOrder.CREATED;

    switch (order.statusId) {
        case ACCESSS_GRANTED:
            status = statusOrder.ACCESS_GRANTED;
            break;
        case ADDRESS_CONFIRMED:
            status = statusOrder.ADDRESS_CONFIRMED;
            break;
        case AGENT_ADDED:
            status = statusOrder.AGENT_ADDED;
            break;
        case DISCLOSURE_UPDATES_IN_PROGRESS:
            status = statusOrder.DISCLOSURE_UPDATES_IN_PROGRESS;
            break;
        case AWAITING_SIGNATURES:
            status = statusOrder.AWAITING_SIGNATURES;
            break;
        case COMPLETE:
            status = statusOrder.COMPLETE;
            break;

    }

    return status;
};

export const disclosureStatus = (order) => {
    let status = disclosure.NOT_STARTED;

    if (disclosureInProgressValues.includes(order.statusId)) {
        status = disclosure.IN_PROGRESS;
    }

    if (order.statusId === COMPLETE) {
        status = disclosure.COMPLETE;
    }

    return status;
};

export const disclosureNotStarted = (disclosureStatus) => {
    return disclosureStatus === disclosure.NOT_STARTED;
};

export const disclosureInProgress = (disclosureStatus) => {
    return disclosureStatus === disclosure.IN_PROGRESS;
};

export const disclosureComplete = (disclosureStatus) => {
    return disclosureStatus === disclosure.COMPLETE;
};

export const hasDisclosureForms = (order) => {
    return (order.forms || []).length > 0 || (invitationMeta(order).forms || []).length > 0;
};

export const usesDocumentGenerator = (order) => {
    const sm = propertyState(order);
    return (sm.id === PA || sm.id === TX || sm.id === NV || sm.id === OK || sm.id === SC || sm.id === NC);
};

//
//   _______  _______  _______  _______  _______  _______ _________         
//   (  ____ )(  ____ )(  ___  )(  ____ )(  ____ \(  ____ )\__   __/|\     /|
//   | (    )|| (    )|| (   ) || (    )|| (    \/| (    )|   ) (   ( \   / )
//   | (____)|| (____)|| |   | || (____)|| (__    | (____)|   | |    \ (_) / 
//   |  _____)|     __)| |   | ||  _____)|  __)   |     __)   | |     \   /  
//   | (      | (\ (   | |   | || (      | (      | (\ (      | |      ) (   
//   | )      | ) \ \__| (___) || )      | (____/\| ) \ \__   | |      | |   
//   |/       |/   \__/(_______)|/       (_______/|/   \__/   )_(      \_/   
//                                                                   

export const propertyStreetAddress = (order) => {
    return (order.property || {}).streetAddress;
};

export const propertyCity = (order) => {
    return (order.property || {}).city;
};

export const propertyState = (order) => {
    return (order.property || {}).state || {};
};

export const propertyStateName = (order) => {
    return (order.property || {}).state.title || {};
}

export const propertyStateMeta = (order) => {
    const meta = (propertyState(order) || {}).meta;
    const inObj = (meta || "{}");
    return JSON.parse(inObj);
};

export const propertyAddress = (order) => {
    const streetAddress = propertyStreetAddress(order) || '';
    const city = propertyCity(order) ? `, ${propertyCity(order)}` : '';
    const state = propertyState(order).slug ? `, ${propertyState(order).slug.toUpperCase()}` : '';

    return `${streetAddress}${city}${state}`;
};

export const isPropertyInformationEditable = (order) => {
    if(order === undefined || order === null) return false;
    let notAccepted = !(order?.invitation?.acceptedAt ?? null);
    let notMigrated = !(order?.oldMigratedId ?? null);
    return notAccepted && notMigrated;
};


//
//     (  ____ \(  ____ \( \      ( \      (  ____ \(  ____ )(  ____ \
//     | (    \/| (    \/| (      | (      | (    \/| (    )|| (    \/
//     | (_____ | (__    | |      | |      | (__    | (____)|| (_____ 
//     (_____  )|  __)   | |      | |      |  __)   |     __)(_____  )
//           ) || (      | |      | |      | (      | (\ (         ) |
//     /\____) || (____/\| (____/\| (____/\| (____/\| ) \ \__/\____) |
//     \_______)(_______/(_______/(_______/(_______/|/   \__/\_______)
//

export const getSellersByField = (order, fieldValue, fieldName = 'type') => {
    let sellers = order.sellers ? order.sellers.toArray().filter(seller => seller && seller[fieldName] === fieldValue) : [];
    if (sellers.length) {
        sellers.forEach((seller, index) => {
            ['firstName', 'lastName', 'phone', 'email'].forEach(attr => {
                if (seller && !seller[attr] && seller?.user && seller?.user[attr]) {
                    sellers[index][attr] = seller.user[attr];
                }
            });
        });
    }
    return sellers;
};

export const getSellerByField = (order, fieldValue, fieldName = 'type') => {
    return getSellersByField(order, fieldValue, fieldName).pop() || {};
};

export const primarySeller = (order) => {
    return order.sellers ? getSellerByField(order, 'primary') : {};
};

export const secondarySeller = (order) => {
    return order.sellers ? getSellerByField(order, 'secondary') : {};
};

export const primarySellerName = (order) => {
    const _primarySeller = primarySeller(order);
    const firstName = _primarySeller.firstName || '';
    const lastName = _primarySeller.lastName ? ` ${_primarySeller.lastName}` : '';

    return `${firstName}${lastName}`;
};

export const primarySellerEmail = (order) => {
    const _primarySeller = primarySeller(order);
    const email = _primarySeller.email || '';
    
    return email;
};

export const hasSecondarySeller = (order) =>{
    let seller = secondarySeller(order);
    return !!seller.firstName && !!seller.lastName || !!seller.email && (!!seller.uuid || !!seller.firstName || !!seller.lastName);
};

export const showSignatureVerification = (order) => {
    let signatures = cloneDeep(order.disclosure?.meta?.signatures) ?? {};
    if (
        signatures.primarySignature &&
        signatures.primaryName &&
        signatures.primaryInitials &&
        signatures.primaryDate && 
        (!hasSecondarySeller(order) || 
            signatures.secondarySignature &&
            signatures.secondaryName &&
            signatures.secondaryInitials &&
            signatures.secondaryDate)
    ) {
        return true;
    }
    return false;
};

export const hasAllSignatures = (order) =>{
    if (order.statusId === COMPLETE && order.oldMigratedId) {
        return true;
      }
      let signatures = cloneDeep(order.disclosure?.meta?.signatures) ?? [];
      if (
          signatures.primarySignature &&
          signatures.primaryName &&
          signatures.primaryInitials &&
          signatures.primaryDate && hasSecondarySignatures(order)
      ) {
          return true;
      }
      return false;
};

export const hasSecondarySignatures = (order) => {
    if (order.statusId === COMPLETE && order.oldMigratedId) {
        return true;
      }
      let signatures = cloneDeep(order.disclosure?.meta?.signatures) ?? [];
      if (
          (signatures.secondarySignature &&
          signatures.secondaryName &&
          signatures.secondaryInitials &&
          signatures.secondaryDate) || !hasSecondarySeller(order)
      ) {
          return true;
      }
      return false;
};

export const agentName = (order) => {
    const agent = order.agent || {};
    const firstName = agent.firstName || '';
    const lastName = agent.lastName ? ` ${agent.lastName}` : '';

    return `${firstName}${lastName}`;
}

//   _________ _                __________________ _______ __________________ _______  _       
//   \__   __/( (    /||\     /|\__   __/\__   __/(  ___  )\__   __/\__   __/(  ___  )( (    /|
//      ) (   |  \  ( || )   ( |   ) (      ) (   | (   ) |   ) (      ) (   | (   ) ||  \  ( |
//      | |   |   \ | || |   | |   | |      | |   | (___) |   | |      | |   | |   | ||   \ | |
//      | |   | (\ \) |( (   ) )   | |      | |   |  ___  |   | |      | |   | |   | || (\ \) |
//      | |   | | \   | \ \_/ /    | |      | |   | (   ) |   | |      | |   | |   | || | \   |
//   ___) (___| )  \  |  \   /  ___) (___   | |   | )   ( |   | |   ___) (___| (___) || )  \  |
//   \_______/|/    )_)   \_/   \_______/   )_(   |/     \|   )_(   \_______/(_______)|/    )_)
//

export const invitationCanBeResent = (order) => {

    let status = disclosureStatus(order);

    if(status == disclosure.NOT_STARTED && order.invitation && !order?.invitation?.acceptedAt){
        return true;
    }
    return false;
};

export const invitationMeta = (order) => {
    const orderInvitation = order.invitation || {};

    return isObject(orderInvitation.meta) ? orderInvitation.meta : {};
}

export const invitationPropertyStreetAddress = (order) => {
    return (invitationMeta(order).property || {}).address;
}

export const invitationPropertyCity = (order) => {
    return (invitationMeta(order).property || {}).city;
}
export const invitationPropertyZip = (order) => {
    return (invitationMeta(order).property || {}).zip;
}

export const invitationPropertyState = (order, states) => {
    const stateId = (invitationMeta(order).property || {}).state;

    return stateId ? states.find(state => state.id === parseInt(stateId)) || {} : {};
}

export const invitationPropertyAddress = (order, states) => {
    const streetAddress = invitationPropertyStreetAddress(order) || '';
    const city = invitationPropertyCity(order) ? `, ${invitationPropertyCity(order)}` : '';
    const state = invitationPropertyState(order, states).slug ? `, ${invitationPropertyState(order, states).slug.toUpperCase()}` : '';

    return `${streetAddress}${city}${state}`;
};

export const invitationPrimarySeller = (order) => {
    return invitationMeta(order).primarySeller || {};
}

export const invitationSecondarySeller = (order) => {
    return invitationMeta(order).secondarySeller || {};
}

export const invitationPrimarySellerName = (order) => {
    const _invitationPrimarySeller = invitationPrimarySeller(order);
    const firstName = _invitationPrimarySeller.firstName || '';
    const lastName = _invitationPrimarySeller.lastName ? ` ${_invitationPrimarySeller.lastName}` : '';

    return `${firstName}${lastName}`;
}

//             ________          _______        _______           _______  _______           _______  _______  _______
//   |\     /|(  ____ \( \      (  ____ )      (  ____ )|\     /|(  ____ )(  ____ \|\     /|(  ___  )(  ____ \(  ____ \
//   | )   ( || (    \/| (      | (    )|      | (    )|| )   ( || (    )|| (    \/| )   ( || (   ) || (    \/| (    \/
//   | (___) || (_____ | |      | (____)|      | (____)|| |   | || (____)|| |      | (___) || (___) || (_____ | (__    
//   |  ___  |(_____  )| |      |  _____)      |  _____)| |   | ||     __)| |      |  ___  ||  ___  |(_____  )|  __)   
//   | (   ) |      ) || |      | (            | (      | |   | || (\ (   | |      | (   ) || (   ) |      ) || (      
//   | )   ( |/\____) || (____/\| )            | )      | (___) || ) \ \__| (____/\| )   ( || )   ( |/\____) || (____/\
//   |/     \|\_______)(_______/|/             |/       (_______)|/   \__/(_______/|/     \||/     \|\_______)(_______/
//

export const hslpStatus = (order) => {
    const hasHslp = order.solutionPurchasedId === SST_HSLP;
    const homeSaleLegalProtection = order.homeSaleLegalProtection || {};

    const payAtClose = (
        (order.paymentTermId === PAY_AT_CLOSE || homeSaleLegalProtection.upsellPaymentTermId === HSLP_PAY_AT_CLOSE) &&
        !order.paymentReceivedAt
    );

    return hasHslp && payAtClose ? hslp.PAY_AT_CLOSE : hasHslp ? hslp.PROTECTED : hslp.NOT_PROTECTED;
};

export const isProtected = (order) => {
    return hslpStatus(order) === hslp.PROTECTED;
};

export const payAtClose = (order) => {
    return hslpStatus(order) === hslp.PAY_AT_CLOSE;
};

export const notProtected = (order) => {
    return hslpStatus(order) === hslp.NOT_PROTECTED;
};

export const purchasedBy = (order) => {
    const homeSaleLegalProtection = order.homeSaleLegalProtection || {};
    const hslpUpsellPurchasedById = homeSaleLegalProtection.upsellPurchasedById;

    if (hslpUpsellPurchasedById) {
        return hslpUpsellPurchasedById === PURCHASED_BY_AGENT ? user.AGENT : user.SELLER;
    } else {
        return order.orderedById === ORDERED_BY_AGENT ? user.AGENT : user.SELLER;
    }
};

export const purchasedByAgent = (order) => {
    return purchasedBy(order) === user.AGENT;
};

export const orderPaymentTermIdFromHslpConvert = (paymentTermId) => {
    switch (paymentTermId) {
        case HSLP_NO_COST :
            return NO_COST;
        case HSLP_BILLED_SEPARATELY :
            return BILLED_SEPARATELY;
    }

    return paymentTermId;
}

export const hslpPaymentTermIdFromOrderConvert = (paymentTermId) => {
    switch (paymentTermId) {
        case NO_COST :
            return HSLP_NO_COST;
        case BILLED_SEPARATELY :
            return HSLP_BILLED_SEPARATELY;
    }

    return paymentTermId;
}

export const hslpBadgeIcon = (order) =>{

    let orderHslpStatus = hslpStatus(order);

    if(orderHslpStatus === hslp.NOT_PROTECTED){
        return hslpBadgeIcons['no-protection'];
    }
    let homeSaleLegalProtection = order.homeSaleLegalProtection || {};
    let year = homeSaleLegalProtection.yearsLegalProtection;
    
    let orderedBy = purchasedBy(order);
    switch(orderHslpStatus){
        case hslp.PAY_AT_CLOSE:
            if(orderedBy == user.AGENT){
                return hslpBadgeIcons[`reserved-${year}-year-agent`];
            }else if(orderedBy == user.SELLER){
                return hslpBadgeIcons[`reserved-${year}-year-seller`];
            }
        case hslp.PROTECTED:
            if(orderedBy == user.AGENT){
                return hslpBadgeIcons[`protected-${year}-year-agent`];
            }else if(orderedBy == user.SELLER){
                return hslpBadgeIcons[`protected-${year}-year-seller`];
            }
    }
    return hslpBadgeIcons['no-protection'];
}

export const getExternalId = (order) => {
    let extId = order.integrationsPlatformId || order.referringPlatformListingId || null;
    return extId;
}

export const orderForms = (order) => {
    let forms = [];
    order.forms.forEach(form =>{
        if(!form.parentFormUuid){
            forms.push(form);
        }
    });
    return forms;
}

export const discountAmount = (hslpPackage, discountAmount, vwoTesting, isSeller = false) => {
    let years = parseInt(hslpPackage.yearsOfProtectionSeller);
    if(vwoTesting && (years === 2 || years === 4) && isSeller){
        if(discountAmount === '15%'){
            hslpPackage.pricePayNowSeller = years === 2 ? 411 : 1029;
            hslpPackage.pricePayAtCloseSeller = years === 2 ? 770 : 1500;
        }else if(discountAmount === '30%'){
            hslpPackage.pricePayNowSeller = years === 2 ? 411 : 1029;
            hslpPackage.pricePayAtCloseSeller = years === 2 ? 790 : 1500;
        }else if(discountAmount === '45%'){
            hslpPackage.pricePayNowSeller = years === 2 ? 411 : 1029;
            hslpPackage.pricePayAtCloseSeller = years === 2 ? 800 : 1500;
        } else {
            hslpPackage.pricePayNowSeller = years === 2 ? 329 : 1559;
            hslpPackage.pricePayAtCloseSeller = years === 2 ? 700 : 1950;
        }
    }

    return hslpPackage;
}